import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import './AutomaticLanding.scss';

import AutomaticTransactionTypes from '../AutomaticTransactionTypes/AutomaticTransactionTypes';
import { getCollegeTypeCount } from '../../../redux/modules/productTypes/productType.selectors';
import {
  APP_FAILURE,
  loadingAutomaticLandingMessages,
  MD529_DECOMMISSION,
  NOT_RETAIL_CLIENT,
  RELOAD_FAILURE,
} from '../../../settings/settings';
import CollegeBrandingContainer from '../../Shared/CollegeBrandingContainer/CollegeBrandingContainer';
import FullPageLoader from '../../Shared/FullPageLoader/FullPageLoader';
import StepsPageBackground from '../../Shared/StepsPageBackground/StepsPageBackground';
import If from '../../Shared/If/If';

export class AutomaticLanding extends Component {
  componentDidMount() {
    const { dispatchPageLoad } = this.props;
    dispatchPageLoad('Landing');
  }

  componentDidUpdate(prevProps) {
    this.checkAppFailed(prevProps);
  }

  checkAppFailed(prevProps) {
    const {
      applicationData: { hasFailed: appFailed },
      dispatchPageLoad,
    } = this.props;
    const {
      applicationData: { isLoading: appWasLoading },
    } = prevProps;

    if (appWasLoading && appFailed) {
      dispatchPageLoad('App Error Page');
    }
  }

  getAppData = (appData) => {
    return appData ? appData : {};
  };

  getAutoInvestments = (autoInvestments) => {
    return autoInvestments ? autoInvestments : {};
  };

  render() {
    const {
      isIFrame,
      isSalesforceRep,
      customerWebViewEnabled,
      applicationData,
      ownsIRAs,
      hasAutoMaxIRAs,
      automaticInvestments,
      personalInformation: { data: personalData },
      recurringRedemptions,
      recurringPurchases,
      autoExchanges,
      getHasCollegeOnly,
      isTraditionalOrRolloverIraFunds,
      isRMDEligible,
      existingRMD,
      systematicActivityRMDs,
      collegeTypeCount,
      RMDSetting: { hasError },
    } = this.props;
    const setUpRmd =
      existingRMD.rmdAgreements && existingRMD.rmdAgreements.length > 0;
    const { retailEnabled } = personalData;
    const getError = () => {
      if (applicationData.hasFailed || (!isSalesforceRep && hasError)) {
        return {
          type: APP_FAILURE,
          hasError: true,
        };
      }
      if (automaticInvestments.autoUpdateReloadFailed) {
        return {
          type: RELOAD_FAILURE,
          hasError: true,
        };
      }
      if (!retailEnabled && !isSalesforceRep && applicationData.isLoaded) {
        return {
          type: NOT_RETAIL_CLIENT,
          hasError: true,
        };
      }
      if (
        !ownsIRAs &&
        recurringRedemptions.length === 0 &&
        recurringPurchases.length === 0 &&
        autoExchanges.length === 0 &&
        collegeTypeCount === 0
      ) {
        return {
          type: MD529_DECOMMISSION,
          hasError: true,
        };
      }
      return {
        type: '',
        hasError: false,
      };
    };
    const appData = this.getAppData(applicationData);
    const autoInvestments = this.getAutoInvestments(automaticInvestments);
    return (
      <div id="automatic-landing-page-container automatic-landing">
        <CollegeBrandingContainer>
          <FullPageLoader
            isVisible={
              autoInvestments.autoUpdateReload ||
              !(appData.hasFailed || appData.isLoaded)
            }
            hasError={getError().hasError}
            errorType={getError().type}
            messages={loadingAutomaticLandingMessages}
          />
          <If
            test={!(isIFrame || (!customerWebViewEnabled && isSalesforceRep))}
          >
            <StepsPageBackground size="small" />
          </If>
          <div className="container">
            <AutomaticTransactionTypes
              isIFrame={isIFrame}
              isSalesforceRep={isSalesforceRep}
              customerWebViewEnabled={customerWebViewEnabled}
              recurringRedemptions={recurringRedemptions}
              recurringPurchases={recurringPurchases}
              autoExchanges={autoExchanges}
              getHasCollegeOnly={getHasCollegeOnly}
              autoInvestments={autoInvestments}
              appData={appData}
              ownsIRAs={ownsIRAs}
              hasAutoMaxIRAs={hasAutoMaxIRAs}
              RMDEligible={
                isTraditionalOrRolloverIraFunds && isRMDEligible && setUpRmd
              }
              systematicActivityRMDs={systematicActivityRMDs}
            />
            <p
              className={
                getHasCollegeOnly ? 'lrn-ref-college' : 'lrn-ref-number'
              }
            >
              2819989
            </p>
          </div>
        </CollegeBrandingContainer>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    collegeTypeCount: getCollegeTypeCount(state),
  };
};

export default compose(connect(mapStateToProps), withRouter)(AutomaticLanding);
